// extracted by mini-css-extract-plugin
export default {"title":"ModalHeader_title__hoWSg","action":"ModalHeader_action__FlEuk"};